import { IState } from '../../../store';

export const getRemovedFromFavorites = (state: IState) => {
  return state.offerData.removedFromFavorites;
};
